// 3rd party
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';

// components
import { InstrumentListComponent } from './instrument-list/instrument-list.component';
import { InstrumentComponent } from 'app/instruments/instrument/instrument.component';

// modules
import { MaterialModule } from 'app/shared/material/material.module';
import { ComponentsModule } from 'app/shared/components/components.module';

// services
import { InstrumentService } from './shared/instrument.service';

@NgModule({
  imports: [
    CommonModule,
    HttpModule,
    FormsModule,
    MaterialModule,
    RouterModule,
    ComponentsModule,
    TranslateModule,
    PdfJsViewerModule,
  ],
  exports: [
    InstrumentListComponent,
    InstrumentComponent
  ],
  declarations: [
    InstrumentListComponent,
    InstrumentComponent
  ],
  providers: [
    InstrumentService
  ]
})
export class InstrumentsModule { }



// WEBPACK FOOTER //
// ./src/app/instruments/instruments.module.ts